import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import HttpClient from 'services/HttpClient';
import TopicItem from '../components/TopicItem';

const TOPICS_REQUEST = '/api/v1/tutorials';

@withRouter
@inject('userStore')
@inject('topicsStore')
@inject('examPrepHeaderStore')
@observer
class TopicList extends Component {
  componentDidMount() {
    const {topicsStore, match, examPrepHeaderStore: {setTopic}, userStore} = this.props;
    const {isAdmin} = userStore;
    const isUserAdmin = isAdmin();
    const id = match.params.id;
    const params = isUserAdmin ? '' : '?tutorial_types=0';

    new HttpClient().get(`${TOPICS_REQUEST}${params}`).then(response => {
      topicsStore.setTopics(response.body.data.tutorial);
    });

    if (id) {
      new HttpClient().get(`${TOPICS_REQUEST}/${id}`).then(data => {
        const topic = data.body.data.tutorial;

        if (topic.tutorial_type !== 'regular') {
            setTopic(topic);
          }
      });
    }
  }

  setTopic = topic => {
    const {topicsStore} = this.props;
    topicsStore.setTopic(topic);
  }

  render() {
    const {topicsStore, userStore} = this.props;
    return (
      <section className="section topics">
        <div className="container-fluid">
          <div className="row justify-content-center list-title">
            <h3>Topic</h3>
          </div>
          <div className="row">
            <div className="container">
              <div className="list-container">
                { topicsStore.letters.map(letter =>
                    <div key={letter} className="topic-block">
                      <div className="row">
                        <div className="topic-block-letter">
                          <span>{letter}</span>
                        </div>
                        <div className="same-letter-wrapper">

                          { topicsStore.topics[letter].map(topic =>
                              <TopicItem
                                key={topic.id}
                                topic={topic}
                                setTopic={this.setTopic}
                                user={userStore.user}
                              />
                            )
                          }
                        </div>
                      </div>
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
} 

export default TopicList;


// WEBPACK FOOTER //
// ./src/modules/topic/containers/TopicsList.js